<template>
    <div>
        <cpo v-if="organizationType === TYPE_CPO" :organization-id="organizationId" />
        <dcs v-else-if="organizationType === TYPE_DCS" :organization-id="organizationId" />
        <direction v-else :organization-id="organizationId" />
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import cpo from './Cpo'
import dcs from './Direction'
import direction from './Direction'
import { TYPE_CPO, TYPE_DCS, TYPE_DIRECTION } from '../../../store/models/organizations/model'
import InitializeMixin from '@/mixins/InitializeMixin'
import ContextMixin from '../../../mixins/ContextMixin'
import OrganizationFetchMixin from '../../../mixins/OrganizationFetchMixin'

export default {
    mixins: [
        InitializeMixin,
        ContextMixin,
        OrganizationFetchMixin
    ],
    components: {
        cpo,
        dcs,
        direction,
    },
    computed: {
        ...mapGetters({
            organizationQuery: 'e/organizations/query',
            currentUser: 'e/users/currentUser',
            currentOrganizationId: 'e/users/currentOrganizationId',
        }),
        organizationId() {
            return this.$route.params.id || null
        },
        organization() {
            return this.organizationQuery().find(this.organizationId)
        },
        organizationType() {
            return this.$_get(this.organization, 'type')
        }
    },
    mounted() {
        this.getOrganization()
    },
    methods: {
        ...mapActions({
            fetchOrganization: 'e/organizations/fetchItems',
        }),
        getOrganization() {
            return new Promise((resolve, reject) => {
                this.fetchOrganizationsIfNeeded().then(resolve).catch(reject)
            })
        },
        contextChangedHandler() {
            if (!this.currentUser.isAdmin) {
                this.$router.push({name: 'organizations.stats.show', params: {id: this.currentOrganizationId}})
            }
        }
    },
    data() {
        return {
            TYPE_CPO,
            TYPE_DCS,
            TYPE_DIRECTION
        }
    },
    watch: {
        organizationId: {
            immediate: true,
            handler () {
                if (!this.organizationId && !this.currentUser.isAdmin) {
                    this.$router.push({name: 'organizations.stats.show', params: {id: this.currentOrganizationId}})
                }
            }
        }
    }
}
</script>